module.exports = __webpack_public_path__ + "static/media/eyeIcon-without-shadow.cc026b3b.svg";